import axios from 'axios';
import { CYLINDO_ACCOUNT_ID } from 'commons/constants';
import { logError } from 'commons/logger';
import { probeLatestVersion } from '../../useCylindoDimensionShots/probeLatestVersion';
import { CYLINDO_CONTENT_API } from './defaults';

export const EMPTY_ENTRY = Object.freeze({
  config: null,
  version: null,
  loading: false,
});

const cylindoConfigPromises = {};
const cylindoStoreEntries = {};
const cylindoStoreListeners = new Set();

const fetchCylindoConfig = productId => {
  if (!cylindoConfigPromises[productId]) {
    cylindoConfigPromises[productId] = axios.get(
      `${CYLINDO_CONTENT_API}/${CYLINDO_ACCOUNT_ID}/products/${productId}/configuration`
    );
  }
  return cylindoConfigPromises[productId];
};

const notifyCylindoStore = () => {
  cylindoStoreListeners.forEach(fn => fn());
};

export const subscribeToCylindoStore = listener => {
  cylindoStoreListeners.add(listener);
  return () => {
    cylindoStoreListeners.delete(listener);
  };
};

export const getCylindoEntry = productId =>
  productId ? cylindoStoreEntries[productId] || EMPTY_ENTRY : EMPTY_ENTRY;

export const requestCylindoFetch = productId => {
  if (!productId || cylindoStoreEntries[productId]) return;

  cylindoStoreEntries[productId] = Object.freeze({
    config: null,
    version: null,
    loading: true,
  });
  notifyCylindoStore();

  fetchCylindoConfig(productId)
    .then(res => {
      if (!res.data) {
        cylindoStoreEntries[productId] = EMPTY_ENTRY;
        notifyCylindoStore();
        return null;
      }
      return probeLatestVersion(productId, res.data.version).then(version => {
        cylindoStoreEntries[productId] = Object.freeze({
          config: res.data,
          version,
          loading: false,
        });
        notifyCylindoStore();
      });
    })
    .catch(e => {
      logError(e);
      cylindoStoreEntries[productId] = EMPTY_ENTRY;
      notifyCylindoStore();
    });
};
